/**
 * @author Camilo Ramirez
 * @Copyright (c)  Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocioConfiguracion } from '../../conexiones';
import ITipoConteoAuditoria from './entidades/ITipoConteoAuditoria';

export default class ModeloTipoConteoAuditoria {
    public consultarTipoConteoAuditoria() {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocioConfiguracion.get('TipoConteoAuditoria/ConsultarListaTipoConteoAuditoria'),
            true
        );
    }
    public crearTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocioConfiguracion.post('TipoConteoAuditoria/GuardarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
    public editarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocioConfiguracion.put('TipoConteoAuditoria/EditarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
    public eliminarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocioConfiguracion.delete('TipoConteoAuditoria/EliminarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
}
